"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.install = install;
exports.default = exports.request = exports.questionnaire = exports.oss = exports.guestUser = exports.createVideo = exports.confim = exports.config = exports.cache = exports.Waterfall = exports.VideoDialog = exports.UserPreference = exports.Upload = exports.Udesk = exports.Tooltip = exports.Tips = exports.Tabs = exports.TabPanel = exports.SubMenu = exports.Select = exports.Rate = exports.QuickLink = exports.Progress = exports.Portal = exports.Popover = exports.Pagination = exports.Navigation = exports.Modal = exports.Message = exports.MenuItem = exports.Menu = exports.LoadMore = exports.LazyImage = exports.Input = exports.Icon = exports.Header = exports.Footer = exports.Filter = exports.FeedbackModal = exports.EditorSidebar = exports.EditorHelp = exports.Button = exports.Badge = exports.AuthModal = exports.Auth = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

require("core-js/modules/es6.function.name");

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _Auth = _interopRequireDefault(require("./Auth"));

exports.Auth = _Auth.default;

var _AuthModal = _interopRequireDefault(require("./AuthModal"));

exports.AuthModal = _AuthModal.default;

var _Badge = _interopRequireDefault(require("./Badge"));

exports.Badge = _Badge.default;

var _Button = _interopRequireDefault(require("./Button"));

exports.Button = _Button.default;

var _EditorHelp = _interopRequireDefault(require("./EditorHelp"));

exports.EditorHelp = _EditorHelp.default;

var _EditorSidebar = _interopRequireDefault(require("./EditorSidebar"));

exports.EditorSidebar = _EditorSidebar.default;

var _FeedbackModal = _interopRequireDefault(require("./FeedbackModal"));

exports.FeedbackModal = _FeedbackModal.default;

var _Filter = _interopRequireDefault(require("./Filter"));

exports.Filter = _Filter.default;

var _Footer = _interopRequireDefault(require("./Footer"));

exports.Footer = _Footer.default;

var _Header = _interopRequireDefault(require("./Header"));

exports.Header = _Header.default;

var _Icon = _interopRequireDefault(require("./Icon"));

exports.Icon = _Icon.default;

var _Input = _interopRequireDefault(require("./Input"));

exports.Input = _Input.default;

var _LazyImage = _interopRequireDefault(require("./LazyImage"));

exports.LazyImage = _LazyImage.default;

var _LoadMore = _interopRequireDefault(require("./LoadMore"));

exports.LoadMore = _LoadMore.default;

var _Menu = _interopRequireDefault(require("./Menu"));

exports.Menu = _Menu.default;

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

exports.MenuItem = _MenuItem.default;

var _Message = _interopRequireDefault(require("./Message"));

exports.Message = _Message.default;

var _Modal = _interopRequireDefault(require("./Modal"));

exports.Modal = _Modal.default;

var _Navigation = _interopRequireDefault(require("./Navigation"));

exports.Navigation = _Navigation.default;

var _Pagination = _interopRequireDefault(require("./Pagination"));

exports.Pagination = _Pagination.default;

var _Popover = _interopRequireDefault(require("./Popover"));

exports.Popover = _Popover.default;

var _Portal = _interopRequireDefault(require("./Portal"));

exports.Portal = _Portal.default;

var _Progress = _interopRequireDefault(require("./Progress"));

exports.Progress = _Progress.default;

var _QuickLink = _interopRequireDefault(require("./QuickLink"));

exports.QuickLink = _QuickLink.default;

var _Rate = _interopRequireDefault(require("./Rate"));

exports.Rate = _Rate.default;

var _Select = _interopRequireDefault(require("./Select"));

exports.Select = _Select.default;

var _SubMenu = _interopRequireDefault(require("./SubMenu"));

exports.SubMenu = _SubMenu.default;

var _TabPanel = _interopRequireDefault(require("./TabPanel"));

exports.TabPanel = _TabPanel.default;

var _Tabs = _interopRequireDefault(require("./Tabs"));

exports.Tabs = _Tabs.default;

var _Tips = _interopRequireDefault(require("./Tips"));

exports.Tips = _Tips.default;

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

exports.Tooltip = _Tooltip.default;

var _Udesk = _interopRequireDefault(require("./Udesk"));

exports.Udesk = _Udesk.default;

var _Upload = _interopRequireDefault(require("./Upload"));

exports.Upload = _Upload.default;

var _UserPreference = _interopRequireDefault(require("./UserPreference"));

exports.UserPreference = _UserPreference.default;

var _VideoDialog = _interopRequireDefault(require("./VideoDialog"));

exports.VideoDialog = _VideoDialog.default;

var _Waterfall = _interopRequireDefault(require("./Waterfall"));

exports.Waterfall = _Waterfall.default;

var _cache = _interopRequireDefault(require("./cache"));

exports.cache = _cache.default;

var _config = _interopRequireDefault(require("./config"));

exports.config = _config.default;

var _confim = _interopRequireDefault(require("./confim"));

exports.confim = _confim.default;

var _createVideo = _interopRequireDefault(require("./createVideo"));

exports.createVideo = _createVideo.default;

var _guestUser = _interopRequireDefault(require("./guestUser"));

exports.guestUser = _guestUser.default;

var _oss = _interopRequireDefault(require("./oss"));

exports.oss = _oss.default;

var _questionnaire = _interopRequireDefault(require("./questionnaire"));

exports.questionnaire = _questionnaire.default;

var _request = _interopRequireDefault(require("./request"));

exports.request = _request.default;
var components = {
  Auth: _Auth.default,
  AuthModal: _AuthModal.default,
  Badge: _Badge.default,
  Button: _Button.default,
  EditorHelp: _EditorHelp.default,
  EditorSidebar: _EditorSidebar.default,
  FeedbackModal: _FeedbackModal.default,
  Filter: _Filter.default,
  Footer: _Footer.default,
  Header: _Header.default,
  Icon: _Icon.default,
  Input: _Input.default,
  LazyImage: _LazyImage.default,
  LoadMore: _LoadMore.default,
  Menu: _Menu.default,
  MenuItem: _MenuItem.default,
  Message: _Message.default,
  Modal: _Modal.default,
  Navigation: _Navigation.default,
  Pagination: _Pagination.default,
  Popover: _Popover.default,
  Portal: _Portal.default,
  Progress: _Progress.default,
  QuickLink: _QuickLink.default,
  Rate: _Rate.default,
  Select: _Select.default,
  SubMenu: _SubMenu.default,
  TabPanel: _TabPanel.default,
  Tabs: _Tabs.default,
  Tips: _Tips.default,
  Tooltip: _Tooltip.default,
  Udesk: _Udesk.default,
  Upload: _Upload.default,
  UserPreference: _UserPreference.default,
  VideoDialog: _VideoDialog.default,
  Waterfall: _Waterfall.default,
  cache: _cache.default,
  config: _config.default,
  confim: _confim.default,
  createVideo: _createVideo.default,
  guestUser: _guestUser.default,
  oss: _oss.default,
  questionnaire: _questionnaire.default,
  request: _request.default
};

function install(Vue) {
  (0, _keys.default)(components).forEach(function (key) {
    if (components[key].install) {
      Vue.use(components[key]);
    } else if (components[key].name) {
      Vue.component(components[key].name, components[key]);
    }
  });
}

var gdui = (0, _assign.default)({
  install
}, components);
var _default = gdui;
exports.default = _default;
var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  install(GlobalVue);
}